// extracted by mini-css-extract-plugin
export default {"componentContainer":"Home_componentContainer__EB+RR"};